import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDL7nd2tS2bosjx95eyI5NxoAAt_x_MuNM",
  authDomain: "patendersyorumlar.firebaseapp.com",
  projectId: "patendersyorumlar",
  storageBucket: "patendersyorumlar.firebasestorage.app",
  messagingSenderId: "894705732234",
  appId: "1:894705732234:web:3d1365d4a1f4ae62467b73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore'u export et
export const db = getFirestore(app);

